import { Component, OnInit } from "@angular/core";
import { OptimizeDialogComponent } from "../optimize-dialog/optimize-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material";
import { EfficiencyService } from "../../efficiency.service";
import { HousesService } from "../../../houses/houses.service";
import { SessionStateService } from "../../../../core/services/session-state.service";
import { Observable } from "rxjs/Observable";

const CYCLE_TYPE = "cycle";
const POWER_TYPE = "power";

@Component({
  selector: "app-redy-tips",
  templateUrl: "./redy-tips.component.html",
  styleUrls: ["./redy-tips.component.scss"],
})
export class RedyTipsComponent implements OnInit {
  dialogRef: MatDialogRef<OptimizeDialogComponent>;
  optimizePowerStatus = "redy";
  optimizeTariffStatus = "redy";
  redyOptimizePower = null;
  redyOptimizeCycle = null;
  loading = false;

  constructor(
    private dialog: MatDialog,
    private sessionStateService: SessionStateService,
    private efficiencyService: EfficiencyService,
    private housesService: HousesService
  ) {}

  ngOnInit() {
    this.loadTips();
  }

  loadTips() {
    this.loading = true;
    this.efficiencyService.getRedyTips().subscribe(
      (res) => {
        let { tariffTips } = res;
        this.loading = false;

        // If there is no information regarding efficiency tips
        if (!tariffTips || Object.keys(tariffTips).length === 0) {
          return;
        }

        if (tariffTips[CYCLE_TYPE]) {
          this.redyOptimizeCycle = tariffTips[CYCLE_TYPE];
        }

        if (tariffTips[POWER_TYPE]) {
          this.redyOptimizePower = tariffTips[POWER_TYPE];
        }

        return;
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  optimizeTariff() {
    this.dialogRef = this.dialog.open(OptimizeDialogComponent, {
      data: {
        type: "tariff",
      },
      autoFocus: false,
      panelClass: "optimizePopup",
    });

    this.dialogRef.componentInstance.action.subscribe((update) => {
      if (update) {
        this.loading = true;
        this.housesService
          .getHouseTariff(this.sessionStateService.getHouse().houseId)
          .catch((err) => {
            this.loading = false;
            return Observable.empty();
          })
          .subscribe((data) => {
            const electricityTariff = data["electricity"];
            this.efficiencyService
              .optimizeCycleTip(
                electricityTariff.type,
                electricityTariff.geography,
                electricityTariff.hourOption,
                this.redyOptimizeCycle.newHourOption,
                electricityTariff.cycle,
                this.redyOptimizeCycle.newCycle
              )
              .finally(() => {
                this.loading = false;
                this.loadTips();
              })
              .catch((err) => {
                return Observable.empty();
              })
              .subscribe();
          });
      }
    });
  }

  optimizePower() {
    this.dialogRef = this.dialog.open(OptimizeDialogComponent, {
      data: {
        type: "power",
      },
      autoFocus: false,
      panelClass: "optimizePopup",
    });

    this.dialogRef.componentInstance.action.subscribe((update) => {
      if (update) {
        this.loading = true;
        this.housesService
          .getHouseTariff(this.sessionStateService.getHouse().houseId)
          .subscribe((data) => {
            const electricityTariff = data["electricity"];
            this.efficiencyService
              .optimizePowerTip(
                electricityTariff.type,
                electricityTariff.geography,
                electricityTariff.power.contracted,
                Number(this.redyOptimizePower.newPower)
              )
              .finally(() => {
                this.loading = false;
                this.loadTips();
              })
              .catch((err) => {
                return Observable.empty();
              })
              .subscribe();
          });
      }
    });
  }

  isLoading() {
    return this.loading;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/efficiency/redy-tips/redy-tips/redy-tips.component.ts